// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonSecondary from "../../../components/landing/ButtonSecondary.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__FeaturesVerticalSlide from "./FeaturesVerticalSlide.js";
import * as Buhta_landing__FeaturesVerticalSlideMobile from "./FeaturesVerticalSlideMobile.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function Features(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const homePage = match[0].homePage;
  return JsxRuntime.jsxs("div", {
    children: [
      country === /* COUNTRY_KAZ */ 1 ? JsxRuntime.jsxs(React.Fragment, {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("img", {
                      src: StaticAsset.src("/static/icons/abacus.svg")
                    }),
                    JsxRuntime.jsx("h2", {
                      children: homePage.feature_heading_1,
                      className: "h6 lg:h5 text-white mt-4 lg:mt-8"
                    }),
                    JsxRuntime.jsx("p", {
                      children: homePage.feature_text_1,
                      className: "paragraph lg:paragraph-large opacity-64 text-white mt-2 lg:mt-4 md:w-100 lg:w-114"
                    })
                  ],
                  className: "lg:w-122"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("img", {
                      src: StaticAsset.src("/static/icons/stonk.svg")
                    }),
                    JsxRuntime.jsx("h2", {
                      children: homePage.feature_heading_2,
                      className: "h6 lg:h5 text-white mt-4 lg:mt-8"
                    }),
                    JsxRuntime.jsx("p", {
                      children: homePage.feature_text_2,
                      className: "paragraph lg:paragraph-large opacity-64 text-white mt-2 lg:mt-4 md:w-100 lg:w-114"
                    })
                  ],
                  className: "lg:w-122 mt-8 md:mt-0"
                })
              ],
              className: "flex m-auto justify-between lg:w-252 flex-col md:flex-row px-6 sm:px-24 lg:px-0"
            }),
            JsxRuntime.jsx("hr", {
              className: "flex m-auto mt-10 lg:mt-30 lg:w-252 mb-10 lg:mb-30 mx-6 lg:mx-auto opacity-16 text-white"
            })
          ]
        }) : null,
      JsxRuntime.jsx("h1", {
        children: homePage.carousel_title,
        className: "h3 text-white sm:text-center ml-6 mr-20 sm:mx-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx("img", {
                className: "inline mr-2",
                src: StaticAsset.src("/static/icons/check2.svg")
              }),
              homePage.carousel_feature_1
            ],
            className: "paragraph lg:paragraph-large text-white mt-2 lg:mt-0"
          }),
          JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx("img", {
                className: "inline mr-2",
                src: StaticAsset.src("/static/icons/check2.svg")
              }),
              homePage.carousel_feature_2
            ],
            className: "paragraph lg:paragraph-large text-white sm:ml-8 mt-2 lg:mt-0"
          }),
          JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx("img", {
                className: "inline mr-2",
                src: StaticAsset.src("/static/icons/check2.svg")
              }),
              homePage.carousel_feature_3
            ],
            className: "paragraph lg:paragraph-large text-white sm:ml-8 mt-2 lg:mt-0"
          })
        ],
        className: "flex justify-center lg:mt-2 flex-col sm:flex-row pl-6 sm:pl-0"
      }),
      deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__FeaturesVerticalSlideMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__FeaturesVerticalSlide.make, {}),
      JsxRuntime.jsx(Buhta_landing__ButtonSecondary.make, {
        classes: {
          hd: "flex m-auto mt-10 lg:mt-30",
          tl: /* [] */ 0
        },
        label: Buhta_landing__I18n.trans(intl, "learn_more_and_prices"),
        route: {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Pricing */ 5
        }
      })
    ],
    className: "bg-primary py-10 lg:py-30"
  });
}

const make = Features;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
